export const menuItemsSelector = ({ menuItems: { items: value = [] } }: any) => value;
export const fetchingItemsSelector = ({ menuItems: { fetchingItems: value = true } }: any) => value;
